import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Power4, gsap } from 'gsap';
import SplitText from 'gsap/SplitText';
import { GetBy } from '../_app/cuchillo/core/Element';
import ScrollItem__Default from './ScrollItem__Default';

class ScrollItem__Footer extends ScrollItem__Default {
    _slider;
    _info;
    _label;
    _separator;

    timeLine;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================

    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this._info = GetBy.selector(".footer__section a", __link);
        this._label = GetBy.selector(".footer__section .label", __link);
        this._separator = GetBy.class("separator", __link);

        this.setupAnimation();

        this.onShow = () => {
           this.timeLine.restart();
        };
    }

    //==================================================================================================================
    //          PUBLIC
    //==================================================================================================================

    setupAnimation() {
        const split_info = new SplitText(this._info, { type: "lines, words " });
        const split_label = new SplitText(this._label, { type: "lines, words " });

        this.doItemsIntoDivs(split_info, 'lines');
        this.doItemsIntoDivs(split_label, 'lines');

        this.timeLine = gsap.timeline({ paused: true });

        let delay = 0;

        for (var i = 0; i < (this._separator.length); i++) {
            this.timeLine.from(this._separator[i], { duration: 1.2, scaleX: 0, ease: "power2.inOut" }, delay +
                i * 0.3);
        }

        delay = 0.7;
        for (var i = 0; i < (split_label.lines.length); i++) {
            this.timeLine.from(split_label.lines[i], { duration: 1.2 + .1 * i, opacity: 0, ease: Power4.easeOut, y: (split_label.lines[0].offsetHeight * 1.5), force3D: true }, delay +
                i * 0.3);
        }
        delay = 1;

        for (var i = 0; i < (split_info.lines.length); i++) {
            this.timeLine.from(split_info.lines[i], { duration: 1.2 + .1 * i, ease: Power4.easeOut, y: (split_info.lines[0].offsetHeight * 1.2), force3D: true }, delay +
                i * 0.3);
        }
    }


    resize(width, height) {
        super.resize(width, height);
    }


    dispose() {
        super.dispose();
    }
}

Scroll._registerClass('footer', ScrollItem__Footer);